import {Image} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {getImageAssetUrl} from '@/_application/core/utils/common';

const socialMediaLinks = [
    {
        href: 'https://www.facebook.com/kidsplaza.com.vn',
        src: 'images/facebook-round-icon.png',
        alt: 'facebook-icon',
    },
    {
        href: 'https://www.youtube.com/user/KidsPlazaChannel?sub_confirmation=1',
        src: 'images/youtube-round-icon.png',
        alt: 'youtube-icon',
    },
    {
        href: 'https://www.tiktok.com/@kidsplazaofficial',
        src: 'images/tiktok-round-icon.png',
        alt: 'tiktok-icon',
    },
    {
        href: 'https://shopee.vn/kidsplaza_official',
        src: 'images/shopee-round-icon.png',
        alt: 'shopee-icon',
    },
];

function ContactUsBlock() {
    return (
        <div>
            <p className="text-[14px] font-bold uppercase leading-[19px] text-primary">Kết nối với chúng tôi</p>
            <div className="mt-3 flex w-full flex-wrap gap-4">
                {socialMediaLinks.map(({href, src, alt}) => (
                    <Link key={href} href={href} target="_blank">
                        <Image src={getImageAssetUrl(src)} alt={alt} width={40} height={40} />
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default ContactUsBlock;
